import styled from 'styled-components';

export const MainWrapper = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.grey001};
`;

export const SidebarWrapper = styled.div`
  flex: 0 0 74px;
`;

export const ContentWrapper = styled.div`
  flex-grow: 1;
`;

export const PageWrapper = styled.div``;
